module.exports = __webpack_public_path__ + "img/icon_integrador_de_dados.e00d18e2.svg";